import { ChevronLeft } from "lucide-react";
import sumanth from "./assets/team1.png";
import vinay from "./assets/team2.png";
import seshu from "./assets/team3.png";
import jeevan from "./assets/jeevan.png";
import vamshi from "./assets/vamshi.png";
import anurag from "./assets/anurag.png";
import sohel from "./assets/team4.png";
import sada from "./assets/sada.png";
import praneeth from "./assets/advisor1.png";
import chaithanya from "./assets/advisor2.png";
import archana from "./assets/advisor3.png";
import shravya from "./assets/shravya.png";
import sravanthi from "./assets/sravanthi.png";
import somnath from "./assets/somnath.png";
import Kaigoulal from "./assets/Kaigoulal.png"; 
import dileep from "./assets/dileep.png";
import kLogo from "./assets/k_logo_final.png";
import { HashLink } from 'react-router-hash-link';
import Navbar from "./components/Navbar";

export default function TeamPage() {
  const coreMembers = [
    { name: "Sumanth", role: "CEO & Chief Political Strategist", img: sumanth, desc: "Leads overall strategy, operations, and vision for Kurukshetra Analytics." },
    { name: "Vinay Kumar", role: "Director of Research & Insights", img: vinay, desc: "Oversees polling, data analytics, and opposition research to guide strategic decisions." },
    { name: "Sheshu", role: "Head of Digital Strategy", img: seshu, desc: "Manages social media, digital campaigns, and online engagement initiatives." },
  ];

  const advisors = [
    { name: "SD Sohel", role: "Strategic Partnerships Director", img: sohel, desc: "Builds and nurtures high-value relationships with political leaders, drives client acquisition, and expands Kurukshetra Analytics’ network and business reach." }, 
    { name: "Dr. Laxmi", role: "Advisor – Women’s Outreach & Advocacy", img: sada, desc: "Leads initiatives focused on women’s engagement, empowerment, and representation, building strong networks and advocacy programs" },
    { name: "Jeevan", role: "Chief Technology Officer", img: jeevan, desc: "Leads all technology initiatives, ensuring innovation and integration of advanced analytics tools." },
    { name: "Archana (IIM) abc", role: "Product & Platform Manager", img: archana, desc: "Oversees development of proprietary political intelligence platforms and campaign dashboards." },
    { name: "Praneeth Chowdary", role: "Public Affairs Manager", img: praneeth, desc: "Builds relationships with media, influencers, and community leaders to shape public perception." },
    { name: "Vamsi Krishna", role: "Research Lead & Narrative Architect", img: vamshi, desc: "Leads the research team in gathering political intelligence, analyzing voter data, and shaping compelling narratives that inform strategy and messaging." },
    { name: "Chaithanya Reddy (Chartered Accountant)", role: "Governance & Public Policy Lead", img: chaithanya, desc: "Evaluates government policies at various levels and provides strategic advice and recommendations to clients." },
    { name: "Dr. Anurag (AIIMS)", role: "Social Media Audit & Listening Lead", img: anurag, desc: "Monitors online conversations, tracks sentiment, and analyzes digital trends to provide real-time insights." },
    { name: "Dr. Shravya", role: "Content & Creative Strategist", img: shravya, desc: "Develops compelling digital storytelling, visual campaigns, and messaging that amplify political narratives and connect with target audiences." },
    { name: "Kaigoulal", role: "Psephologist", img: Kaigoulal, desc: "Specializes in analyzing electoral data, voter behavior, and demographic trends to generate accurate forecasts and actionable insights." },
    { name: "Somnath", role: "Innovation & Strategy Consultant", img: somnath, desc: "Designs new frameworks and solutions to improve campaign efficiency." },
    { name: "Sravanthi", role: "Media and Communications Planner", img: sravanthi, desc: "Plans and coordinates media strategies, oversees communication campaigns, and ensures cohesive messaging across all platforms." },
    
  ];
  return (
    <div className="min-h-screen bg-[#0B0A17] text-white font-sans">
      
      {/* MAIN CONTENT */}
      <section className="pt-24 px-6 md:px-12 lg:px-20">
        <Navbar />
        <TeamSection />
       
      </section>
    </div>
  );
}

function Nav2() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-black/20 backdrop-blur-md">
      <div className="w-full px-6 md:px-12 lg:px-20 py-4 flex items-center justify-between">
        {/* Logo + Brand */}
        <a href="/" className="flex items-center gap-3 group">
          <img
            src={kLogo}
            alt="Kurukshetra Analytics"
            className="h-8 w-auto transition duration-300 group-hover:scale-110"
          />
          <span className="font-semibold tracking-wide text-white">
            Kurukshetra Analytics
          </span>
        </a>

        {/* Nav Links */}
        <nav className="hidden md:flex items-center gap-8 text-sm text-white/80">
        
          <HashLink smooth to="/#showcase" className="hover:text-white transition"> What we do</HashLink>
          
          <HashLink smooth to="/#insights" className="hover:text-white transition"> Insights</HashLink>
          <a className="hover:text-white transition" href="/solutions">Our Solutions</a>
          <a className="hover:text-white transition" href="/team">Our Team</a> 
          <a className="hover:text-white transition" href="/testimonials">Testimonials</a>
          <HashLink smooth to="/#getintouch" className="hover:text-white transition"> Contact Us</HashLink>
        </nav>

        {/* Contact Button */}
        <a
  href="https://wa.me/919876543210" // replace with your real number (no '+' sign, no spaces)
  target="_blank"
  rel="noopener noreferrer"
  className="inline-flex items-center gap-2 rounded-2xl px-4 py-2 text-white hover:opacity-90"
  style={{fontSize: "14px"}}
  
>
  📞 Call / WhatsApp: <span className="whitespace-nowrap">+91 99511 86186</span>
</a>

      </div>
    </header>
  );
}


function TeamSection() {
  const coreMembers = [
    { name: "Sumanth", role: "CEO & Chief Political Strategist", img: sumanth, desc: "Leads overall strategy, operations, and vision for Kurukshetra Analytics." },
    { name: "Vinay Kumar", role: "Director of Research & Insights", img: vinay, desc: "Oversees polling, data analytics, and opposition research to guide strategic decisions." },
    { name: "Sheshu", role: "Head of Digital Strategy", img: seshu, desc: "Manages social media, digital campaigns, and online engagement initiatives." },
  ];

  const advisors = [
    { name: "Shravani (IIM)", role: "Product & Platform Head", img: archana, desc: "Oversees development of proprietary political intelligence platforms and campaign dashboards." },
    { name: "Praneeth", role: "Head of Public Affairs", img: praneeth, desc: "Builds relationships with media, influencers, and community leaders to shape public perception." },
    { name: "Vamsi Krishna", role: "Research Lead & Narrative Architect", img: vamshi, desc: "Leads the research team in gathering political intelligence, analyzing voter data, and shaping compelling narratives that inform strategy and messaging." },
    { name: "Dileep", role: "Head Content & Creative Strategist", img: dileep, desc: "Develops compelling digital storytelling, visual campaigns, and messaging that amplify political narratives and connect with target audiences." },
    { name: "SD Sohel", role: "Strategic Partnerships Director", img: sohel, desc: "Builds and nurtures high-value relationships with political leaders, drives client acquisition, and expands Kurukshetra Analytics’ network and business reach." }, 
    { name: "Dr. Laxmi", role: "Advisor – Women’s Outreach & Advocacy", img: sada, desc: "Leads initiatives focused on women’s engagement, empowerment, and representation, building strong networks and advocacy programs" },
    { name: "Jeevan", role: "Chief Technology Officer", img: jeevan, desc: "Leads all technology initiatives, ensuring innovation and integration of advanced analytics tools." },
    { name: "Chaithanya Reddy (Chartered Accountant)", role: "Governance & Public Policy Lead", img: chaithanya, desc: "Evaluates government policies at various levels and provides strategic advice and recommendations to clients." },
    { name: "Dr. Anurag (AIIMS)", role: "Social Media Audit & Listening Lead", img: anurag, desc: "Monitors online conversations, tracks sentiment, and analyzes digital trends to provide real-time insights." },
    { name: "Dr. Shravya", role: "Content & Creative Strategist", img: shravya, desc: "Develops compelling digital storytelling, visual campaigns, and messaging that amplify political narratives and connect with target audiences." },
    { name: "Kaigoulal", role: "Psephologist", img: Kaigoulal, desc: "Specializes in analyzing electoral data, voter behavior, and demographic trends to generate accurate forecasts and actionable insights." },
    { name: "Somnath", role: "Innovation & Strategy Consultant", img: somnath, desc: "Designs new frameworks and solutions to improve campaign efficiency." },
    { name: "Sravanthi", role: "Media and Communications Planner", img: sravanthi, desc: "Plans and coordinates media strategies, oversees communication campaigns, and ensures cohesive messaging across all platforms." },
    
  ];

  return (
        
    <div className="min-h-screen bg-[#0B0A17] text-white px-6 md:px-12 lg:px-20 py-16">
      {/* Back button */}
    
      {/* Header */}
      <h1 className="text-4xl font-semibold mb-2">Meet the Team</h1>
      <p className="text-white/70 max-w-2xl mb-12">
        We’re a collective of strategists, researchers, and campaign specialists
        dedicated to transforming democratic engagement through credible data,
        technology, and grassroots intelligence.
      </p>

      {/* Core Team */}
      <section className="mb-16">
        <h2 className="text-2xl font-semibold mb-6 text-[#A78BFA]">
          Core Team
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {coreMembers.map((m, i) => (
            <div
              key={i}
              className="rounded-3xl overflow-hidden border border-white/10 bg-white/5 hover:bg-white/10 transition p-5 text-center"
            >
              <div className="h-56 w-full overflow-hidden rounded-2xl mb-4">
                <img
                  src={m.img}
                  alt={m.name}
                  className="h-full w-full object-cover"
                />
              </div>
              <h3 className="text-lg font-semibold">{m.name}</h3>
              <p className="text-sm text-white/70">{m.role}</p>
              <p className="text-white/60 text-sm mt-3">{m.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Advisors */}
      <section>
        
        <div className="grid md:grid-cols-3 gap-8">
          {advisors.map((a, i) => (
            <div
              key={i}
              className="rounded-3xl overflow-hidden border border-white/10 bg-white/5 hover:bg-white/10 transition p-5 text-center"
            >
              <div className="h-56 w-full overflow-hidden rounded-2xl mb-4">
                <img
                  src={a.img}
                  alt={a.name}
                  className="h-full w-full object-cover"
                />
              </div>
              <h3 className="text-lg font-semibold">{a.name}</h3>
              <p className="text-sm text-white/70">{a.role}</p>
              <p className="text-white/60 text-sm mt-3">{a.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Footer note */}
      <p className="mt-16 text-center text-white/60 text-sm">
        © {new Date().getFullYear()} Kurukshetra Analytics — All rights reserved.
      </p>
    </div>
    
  );
}
